import React from 'react';
import { AppBar, Badge, Paper, Typography, Alert } from '@mui/material';
import { Toolbar } from '@mui/material';
import { IconButton } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import PropTypes from 'prop-types';
import { NUMBER, TOAST_OPTIONS } from '../../constants/app-constants';
import { useSelector } from 'react-redux';
import SearchBar from './SearchBar';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from '../../constants/route-constants';
import { isValidDealer } from '../../utils/is-valid-dealer';
import { prepareGADataAndSendEvent } from '../../tracking';
import { getItem } from '../../utils/helpers/storage-crud';
const styles = {
    color: '#FFFFFF',
};

const Header = ({ options }) => {
    const { user, notification: { unseen } } = useSelector(state => state);
    const { status } = user || {};
    const { search = true, wisList = true, notification = true, title, back, backRoute = -NUMBER.ONE, position = 'relative' } = options || {};
    const eligibleForBid = isValidDealer(status);
    const navigate = useNavigate();
    const isWebView = getItem('isWebView');
    const handleBack = () => {
        navigate(backRoute);
    };

    const handleNotifications = () => {
        prepareGADataAndSendEvent('bellClick', user, null, 'Header');
        navigate(ROUTE_PATH.NOTIFICATIONS);
    };

    const handleWatchList = () => {
        prepareGADataAndSendEvent('watchListIconClick', user, null, 'Header');
        navigate(ROUTE_PATH.WATCH_LIST);
    };
    return (
        <Paper
            sx={{ position, top: 0, left: 0, right: 0, margin: '0 -16px', zIndex: 9 }}
            elevation={0}
        >
            <AppBar position="static" sx={{ p: title ? '5px' : '15px 0' }}>
                <Toolbar variant="dense" sx={{ display: 'flex', justifyContent: 'space-between' }} style={styles}>
                    {search && <SearchBar eligibleForBid={eligibleForBid} />}
                    {(title && !isWebView) && <Typography variant='h6' className='w-full text-center text-white'>
                        {back && <ArrowBackIcon className='text-white absolute left-2' onClick={handleBack} />}
                        {title}
                    </Typography>}
                    {wisList && <IconButton type="button" sx={{ p: '10px', fontSize: '30px' }} style={styles} aria-label="search" onClick={handleWatchList}>
                        <FavoriteBorderIcon style={{ fontSize: '30px' }} />
                    </IconButton>}
                    {notification && <Badge badgeContent={unseen} classes={{ badge: 'text-white font-semibold text-lg right-1 top-2 bg-danger' }} color="primary" onClick={handleNotifications}>
                        <NotificationsNoneOutlinedIcon style={{ fontSize: '30px', ...styles }} />
                    </Badge>}
                </Toolbar>
            </AppBar>
            {!eligibleForBid && <Alert severity={TOAST_OPTIONS.WARN}>You are not eligible for bid, please contact your RM</Alert>}
        </Paper>
    );
};

Header.propTypes = {
    options: PropTypes.object,
    status: PropTypes.string
};
export default Header;
